import { Link } from "react-router-dom";
import { Phone, Music2, Instagram, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-zinc-900 bg-zinc-950">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 bg-teal-400 grid place-items-center shrink-0">
                <span className="font-display font-bold text-zinc-950 text-lg leading-none">T</span>
              </div>
              <div className="leading-tight">
                <div className="font-display font-semibold tracking-tight uppercase text-base">
                  Tribal <span className="text-teal-400">Designz</span>
                </div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-gold font-semibold">
                  Pacific Heritage Uniforms
                </div>
              </div>
            </div>
            <p className="mt-4 text-zinc-400 text-sm leading-relaxed max-w-md">
              Custom Samoan, Tongan and Cook Islands polo uniforms for Pacific
              churches, ministries, choirs, conferences and reunion groups
              across Auckland and New Zealand.
            </p>
            <p className="mt-3 text-zinc-500 text-xs uppercase tracking-wider">
              Auckland · Aotearoa NZ
            </p>
          </div>

          <div>
            <h4 className="font-display uppercase tracking-wider text-sm text-gold">Collections</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/samoan-church-uniforms" className="text-zinc-300 hover:text-teal-400">Samoan Church Uniforms</Link></li>
              <li><Link to="/tongan-church-uniforms" className="text-zinc-300 hover:text-teal-400">Tongan Church Uniforms</Link></li>
              <li><Link to="/cook-islands-uniforms" className="text-zinc-300 hover:text-teal-400">Cook Islands Uniforms</Link></li>
              <li><Link to="/church-conference-uniforms" className="text-zinc-300 hover:text-teal-400">Church Conference Uniforms</Link></li>
              <li><Link to="/reunion-polo-shirts" className="text-zinc-300 hover:text-teal-400">Reunion Polo Shirts</Link></li>
              <li><Link to="/church-uniforms-auckland" className="text-zinc-300 hover:text-teal-400">Church Uniforms Auckland</Link></li>
              <li><Link to="/blog" className="text-zinc-300 hover:text-teal-400">Blog</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display uppercase tracking-wider text-sm text-gold">Reach us</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a
                  href="tel:+64221012443"
                  data-testid="footer-phone"
                  className="flex items-center gap-2 text-zinc-300 hover:text-teal-400"
                >
                  <Phone size={14} /> +64 22 101 2443
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/64221012443"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-whatsapp"
                  className="flex items-center gap-2 text-zinc-300 hover:text-teal-400"
                >
                  <MessageCircle size={14} /> WhatsApp us
                </a>
              </li>
              <li>
                <a
                  href="https://www.tiktok.com/@tribaldesignzco"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-tiktok"
                  className="flex items-center gap-2 text-zinc-300 hover:text-teal-400"
                >
                  <Music2 size={14} /> @tribaldesignzco
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com/tribaldesignznz"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-instagram"
                  className="flex items-center gap-2 text-zinc-300 hover:text-teal-400"
                >
                  <Instagram size={14} /> Instagram
                </a>
              </li>
            </ul>
            <p className="mt-6 text-[11px] uppercase tracking-wider text-zinc-600">
              Also serving: <Link to="/custom-rugby-uniforms-nz" className="hover:text-zinc-400">Rugby</Link> ·{" "}
              <Link to="/custom-basketball-jerseys-nz" className="hover:text-zinc-400">Basketball</Link> ·{" "}
              <Link to="/fast-tshirt-printing-auckland" className="hover:text-zinc-400">DTF Print</Link>
            </p>
          </div>
        </div>

        <div className="section-divider mt-12" />
        <div className="mt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-zinc-500">
          <span>© {new Date().getFullYear()} Tribal Designz — All rights reserved.</span>
          <span className="uppercase tracking-[0.2em]">Auckland · Aotearoa NZ</span>
        </div>
      </div>
    </footer>
  );
}
